export default __webpack_public_path__ + "static/media/avatar3.87e7d1b1.svg";